<script setup lang="ts"></script>

<template>
  <dialog id="contactModal" class="modal">
    <div class="modal-box rounded-xs">
      <form method="dialog">
        <button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">
          ✕
        </button>
      </form>

      <p>
        Lets chat! Give me your name, email address and some details about the
        project & I'll get back to you as soon as possible 🤙🏽
      </p>

      <form
        name="contact"
        method="POST"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        class="w-full max-w-lg"
        action="/success"
      >
        <fieldset>
          <input type="hidden" name="contact" value="contact" />

          <div>
            <label for="name" class="block mt-7 mb-2">Your full name</label>
            <input
              type="text"
              name="name"
              class="text-gray-700 focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-xs border-gray-300 p-2"
              placeholder="Agent Smith"
              aria-label="Your full name"
              required
            />
          </div>

          <div>
            <label for="email" class="block mt-7 mb-2"
              >Your Email address</label
            >
            <input
              id="email"
              name="email"
              type="email"
              class="text-gray-700 focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-xs border-gray-300 p-2"
              aria-label="Your email address"
              placeholder="someone@domain.com"
              required
            />
          </div>

          <div>
            <label for="message" class="block mt-7 mb-2"
              >Tell me a little about what you'd like help with</label
            >
            <textarea
              id="message"
              rows="3"
              class="text-gray-700 shadow-xs focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-xs p-2"
              name="message"
              placeholder="Provide as much information as possible to help me, help you"
              required
            />
          </div>

          <button
            type="submit"
            class="btn btn-primary px-8 mt-10 block mr-0 ml-auto"
          >
            Send your message
          </button>
        </fieldset>
      </form>
    </div>
  </dialog>
</template>
